import React from 'react';
import { ToastContainer } from 'react-toastify';
//styles
import 'react-toastify/dist/ReactToastify.min.css';

const Toastify: React.FC = () => {
  return <ToastContainer />;
};

export default Toastify;